<template>
    <div :class="{'has-background-light': hasBgGrey}" class="box">
        <router-link :to="{ name: 'detail', params: {id: docNum} }" class="has-text-grey-darker">
            <div class="columns is-mobile is-multiline is-marginless">
                <div class="column is-full-mobile is-paddingless">
                    <div class="columns is-mobile is-marginless">
                        <div class="column is-2 is-paddingless">
                            <p class="has-text-weight-bold">{{ docNum }}</p>
                        </div>
                        <div class="column is-5 is-paddingless">
                            <p class="has-text-weight-bold">{{ requester }}</p>
                        </div>
                        <div class="column is-5 is-paddingless has-text-right-mobile">
                            <p class="has-text-weight-bold">{{ department }}</p>
                        </div>
                    </div>
                </div>
                <div class="column is-full-mobile is-paddingless">
                    <div class="columns is-mobile is-marginless">
                        <div class="column is-paddingless">
                            <p>{{ tpSolicitacao }}</p>
                        </div>
                        <div class="column is-paddingless has-text-right-mobile has-text-centered-desktop">
                            <p>{{ formattedDate(docDate) }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
    import mixin from "./detailMixin";

    export default {
        name: 'ListItem',
        mixins: [mixin],
        props: ['docNum', 'docDate', 'department', 'requester', 'tpSolicitacao', 'docEntry'],
        computed: {
            hasBgGrey() {
                return this.index % 2 !== 0;
            }
        }
    }
</script>

<style lang="scss" scoped>
    p {
        font-size: 14px;
    }

    .level {
        margin-bottom: 8px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .box {
        margin-bottom: 8px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    @media (max-width: 768px) {
        .column.is-full-mobile {
            &:last-child {
                margin-top: 8px !important;
            }
        }
    }
</style>
